const noPaddingActionTypes = {
  SET_NO_PADDING: "SET_NO_PADDING",
};

export default noPaddingActionTypes;
